import React, { Component } from 'react';
import Modal from 'react-modal';
import { Spinner } from 'react-activity';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

class AddNotes extends Component {
    render() {
        return (
            <Modal
                isOpen={this.props.openModal}
                onRequestClose={this.props.closeAddNotesModal}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                className={'modal-width'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative bg-[#181B22] rounded-lg p-5">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-semibold text-white">
                                {this.props.t('addNotes')}
                            </h3>
                            <button type="button" onClick={() => this.props.closeAddNotesModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        fill="white"
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="border border-[#34373E] my-4"></div>
                        <label
                            htmlFor="select-subcategory"
                            className="block mb-2 text-base font-normal rounded-lg text-white mt-6 
             after:content-['*'] after:ml-0.5 after:[color:#10DACE]"
                        >
                            {this.props.t('summary')}
                        </label>
                        <div className="py-1">
                            <textarea
                                id="notesSummary"
                                name="notesSummary"
                                rows="3"
                                onChange={(event) => {
                                    this.props.onChange(event);
                                }}
                                placeholder={this.props.t('summaryPlaceholder500')}
                                className="px-3 py-2 block w-full rounded-lg bg-[#23262D] text-white placeholder:text-secondary sm:text-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
                                maxLength={500}
                            />
                        </div>
                        <div>
                            <div className="order-last mb-2 sm:order-first">
                                <label
                                    htmlFor="select-about"
                                    className="block mt-6 mb-2 text-base font-normal text-white rounded "
                                >
                                    {this.props.t('materialImagesPDF')}
                                </label>
                                <div className="mt-2 flex justify-center rounded-lg bg-[#23262D] ">
                                    <div className="mt-6 text-center">
                                        <input
                                            type="file"
                                            multiple
                                            id="file-upload"
                                            name="file-upload"
                                            className="sr-only"
                                            onClick={(e) => {
                                                e.target.value = null;
                                            }}
                                            onChange={this.props.handleFileUpload}
                                            accept=".png,.jpeg,.jpg,.pdf"
                                        />
                                        <label
                                            htmlFor="file-upload"
                                            className="relative flex items-center justify-center p-8"
                                        >
                                            <span className="text-white">
                                                <div className="w-10 h-10 bg-[#543CC2] rounded-full flex items-center justify-center p-[14px] mx-auto">
                                                    <svg
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M5 10H15"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M10 15V5"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                                <div className="flex mt-4 text-sm leading-6 text-white">
                                                    <p className="pl-1 font-normal text-white text-medium text-nowrap">
                                                        {this.props.t('uploadInstructions10MB')}
                                                    </p>
                                                </div>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                {this.props.materialUploadedImages &&
                                this.props.materialUploadedImages.length ? (
                                    <div className="flex flex-row flex-wrap w-auto gap-4 mt-4 bg-transparent rounded-lg max-w-fit">
                                        {this.props.materialUploadedImages.map((res, index) => {
                                            const fileExtension = res.split(';')[0].split('/')[1];
                                            if (fileExtension === 'pdf') {
                                                return (
                                                    <div
                                                        className="relative upload border border-[#34373E]"
                                                        key={index}
                                                    >
                                                        <span
                                                            className="cursor-pointer fas fa-times-circle text-red"
                                                            style={{
                                                                position: 'absolute',
                                                                right: '-5px',
                                                                top: '-5px',
                                                            }}
                                                            onClick={() => {
                                                                this.props.removeImage(index);
                                                            }}
                                                        ></span>
                                                        <a
                                                            href={res}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <i
                                                                className="fa-solid fa-file-pdf"
                                                                style={{
                                                                    color: '#c30909',
                                                                    width: '5rem',
                                                                    height: '5rem',
                                                                    borderRadius: '0.25rem',
                                                                    fontSize: '70px',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                }}
                                                            ></i>
                                                        </a>
                                                    </div>
                                                );
                                            } else {
                                                return (
                                                    <div className="relative upload" key={index}>
                                                        <span
                                                            className="cursor-pointer fas fa-times-circle text-red"
                                                            style={{
                                                                position: 'absolute',
                                                                right: '-5px',
                                                                top: '-5px',
                                                            }}
                                                            onClick={() => {
                                                                this.props.removeImage(index);
                                                            }}
                                                        ></span>
                                                        <a
                                                            href={res}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <img
                                                                src={res}
                                                                className="w-20 h-20 rounded"
                                                                key={index}
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <div className="flex items-center justify-end pt-6 space-x-2">
                            <button
                                data-modal-hide="defaultModal"
                                className="text-white bg-black rounded-lg font-semibold text-base w-3/12 py-1.5"
                                onClick={() => this.props.closeAddNotesModal()}
                            >
                                {this.props.t('close')}
                            </button>
                            &nbsp;&nbsp;
                            <button
                                data-modal-hide="defaultModal"
                                className="text-white bg-UIprimary rounded-lg font-semibold text-base w-3/12 py-1.5"
                                onClick={() => {
                                    this.props.submitAddNotes();
                                }}
                                disabled={this.props.submitBtnLoading}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.props.submitBtnLoading ? (
                                        <Spinner color="#FFF" />
                                    ) : (
                                        this.props.t('save')
                                    )}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const ConnectedAddNotes = withLanguage(AddNotes);

export default (props) => (
    <LanguageProvider>
        <ConnectedAddNotes {...props} />
    </LanguageProvider>
);
